import { useEffect, useState } from 'react'
import { adminApi } from '../../services/adminApi'
import type { EmailTemplate, TemplateCategory } from '../../types/communications'

interface TemplatePickerProps {
    category: TemplateCategory
    value: string | null
    onChange: (templateId: string | null, template: EmailTemplate | null) => void
}

export function TemplatePicker({ category, value, onChange }: TemplatePickerProps) {
    const [items, setItems] = useState<EmailTemplate[]>([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setLoading(true)
        adminApi
            .getEmailTemplates({ category })
            .then(r => {
                setItems(r.items)
                setLoading(false)
            })
            .catch(() => setLoading(false))
    }, [category])

    return (
        <select
            value={value ?? ''}
            onChange={e => {
                const id = e.target.value || null
                onChange(id, id ? items.find(i => i.id === id) ?? null : null)
            }}
            className="block w-full rounded-md border border-gray-300 px-3 py-2 text-sm"
            disabled={loading}
        >
            <option value="">{loading ? 'Loading templates…' : '— no template —'}</option>
            {items.map(t => (
                <option key={t.id} value={t.id}>
                    {t.name ?? t.key} · v{t.version}
                </option>
            ))}
        </select>
    )
}
